/**
 * Mutations for the configurator store module.
 * @module configurator/mutations
 */

export default {
  /**
   * Set the venues in the state.
   * @param {Object} state - The Vuex state object.
   * @param {Array} venues - The venues to set.
   */
  setVenues(state, venues) {
    state.venues = venues;
  },

  /**
   * Set the related venues in the state.
   * @param {Object} state - The Vuex state object.
   * @param {Array} relatedVenues - The related venues to set.
   */
  setRelatedVenues(state, relatedVenues) {
    state.relatedVenues = relatedVenues;
  },

  /**
   * Set the current venue in the state.
   * @param {Object} state - The Vuex state object.
   * @param {string} venue - The current venue to set.
   */
  setCurrentVenue(state, venue) {
    state.currentVenue = venue;
  },
  /**
   * Sets the loading state for venues.
   *
   * @param {Object} state - The Vuex state object.
   * @param {boolean} loading - The loading state to set.
   */
  setVenuesLoading(state, loading) {
    state.venuesLoading = loading;
  }
};
